/* global Forms, Units, $, Departments, gon, I18n */

import ApplicationController from '../application_controller'
import 'lib/departments'
import AbilitySelector from 'lib/ability_selector'

class EditFormController extends ApplicationController {
  static values = {
    newRecord: Boolean
  }

  connect () {
    this.rolesLogic()
    Units.departmentsSelect()
    Units.addressesSelect()

    if (this.newRecordValue) return

    $('.select2-limited').select2({
      maximumSelectionSize: 3
    })

    Departments.addressesSelect()
    Forms.initPasswordChecker()
    // $('#user_related_unit_ids').trigger('change')
  }

  rolesLogic () {
    const abilitySelector = new AbilitySelector(gon, 'user')
    $('.user_role select').off('change.userRole').on('change.userRole', function () {
      const role = $(this).val()
      $('#abilities_collection_block').addClass('loading')
      return $.ajax({
        url: '/users/additional_abilities',
        data: {
          role,
          user_id: gon.user_id
        },
        success: function () {
          Forms.initCheckbox()
          return $('#abilities_collection_block').removeClass('loading')
        }
      })
    })

    // Set preset as "Custom" if advanced settings were changed
    $(document).off('change.userRolePreset').on('change.userRolePreset', '.user_role input, #abilities_collection_block input, select#user_role, #users_related_projects, #user_admin', function () {
      $('#user_permission_preset_id').prop('selectedIndex', 0).find(':selected').text(I18n.t('custom_preset'))
    })

    $('#user_permission_preset_id').off('change.presetRole').on('change.presetRole', function () {
      const role = $(this).find(':selected').data('role')
      const admin = $(this).find(':selected').data('admin')
      const presetId = $(this).val()
      $.getJSON('/permission_presets/' + presetId, function (data) {
        gon.selected_locations = data.related_locations
        gon.selected_projects = data.related_projects
        gon.selected_units = data.related_units
        gon.selected_departments = data.related_departments
      })
      $.ajax({
        url: '/permission_presets/additional_abilities',
        data: {
          role,
          preset_id: presetId,
          model_name: 'user'
        },
        dataType: 'script',
        success: function () {
          Forms.initCheckbox()
          abilitySelector.init_checked()
          $('.user_role select').val(role).select2()
          $('#user_admin').prop('checked', admin)
        }
      })
    })
  }
}

export default EditFormController
